/* global http */
const modal = {
	el: {
		body: document.body,
		header: document.querySelector('.header'),
		modals: document.querySelectorAll('.modal'),
		modalHeader: document.querySelector('.modal__header-copy'),
		modalTitle: document.querySelector('.modal__heading'),
		modalFlyerCourse: document.querySelector('.modal__grid-heading'),
		modalFlyerInfo: document.querySelector('.modal__grid-posheading'),
		modalFlyerImage: document.querySelector('.modal__grid-image'),
		modalList: document.querySelector('.modal__list'),
		modalCards: document.querySelector('.modal__cards'),
		modalContent: document.querySelector('.modal__content'),
		modalPrizesType: document.querySelector('.js-prizes-type'),
		modalPrizesPartner: document.querySelector('.js-prizes-partner'),
		modalPrizesContent: document.querySelector('.js-prizes-content'),
		modalPrizesCaption: document.querySelector('.js-prizes-caption'),
		modalOpen: document.querySelectorAll('.js-open-modal'),
		modalClose: document.querySelectorAll('.js-close-modal')
	},

	fxGetTableStudies(element) {
		const endpoint = `${element.closest('.js-modal-endpoint').dataset.endpoint}${element.dataset.tableId}`

		const callback = response => {
			const data = response.data
			document.querySelector('.modal-studyplans .modal__preloader').classList.add('d-none')

			if (response.status === 200) {
				this.el.modalTitle.textContent = data.title
				this.el.modalCards.querySelector('.modal__item-heading').textContent = data.teachers.title

				data.list.forEach(el => {
					this.el.modalList.innerHTML +=
						`
							<li class="modal__item">
								<h3 class="modal__item-heading">${el.title}</h3>
								<h4 class="modal__item-copy">${el.copy}</h4>
							</li>
						`
				})

				data.teachers.cards.forEach(el => {
					this.el.modalCards.querySelector('.card-avatar').innerHTML +=
						`
							<li class="card-avatar__item columns-2">
								<div class="card-avatar__wrap">
									<figure class="card-avatar__figure">
										<img class="card-avatar__image img-full img-circle" src="${el.image}" alt="${el.name}" data-object-fit="cover">
									</figure>
									<div class="card-avatar__content">
										<div class="card-avatar__heading gamma">${el.name}</div>
										<div class="card-avatar__posheading">${el.job}</div>
										<a class="card-avatar__link" href="mailto:${el.email}">${el.email}</a>
									</div>
								</div>
							</li>
						`
				})
			}
		}

		document.querySelector('.modal-studyplans .modal__preloader').classList.remove('d-none')
		http.fxGet(endpoint, callback)
	},

	fxGetTablePrizes(element) {
		const endpoint = element.parentElement.dataset.endpoint

		const callback = response => {
			const data = response.data
			document.querySelector('.modal-prizes .modal__preloader').classList.add('d-none')

			//prevent Duplicates
			this.el.modalPrizesContent.innerHTML = ''
			this.el.modalPrizesCaption.innerHTML = ''

			data.results.forEach(el => {
				if (response.status === 200 && Number(element.dataset.prizeId) === el.id) {
					this.el.modalHeader.textContent = el.title
					this.el.modalPrizesType.textContent = el.prizeType
					this.el.modalPrizesPartner.textContent = el.partner ? `(${el.partner})` : ''

					el.info.forEach(el => {
						this.el.modalPrizesContent.innerHTML +=
							`
								<tr class="table__row">
									<td class="table__cell"><span class="table__cell-copy">${el.class}</span></td>
									<td class="table__cell"><span class="table__cell-copy">${el.course}</span></td>
									<td class="table__cell text-right"><span class="table__cell-copy">${el.prize}</span></td>
								</tr>
							`
					})

					el.caption.forEach(el => this.el.modalPrizesCaption.innerHTML += `<li class="table__caption-item">${el.item}</li>`)
				}
			})
		}
		document.querySelector('.modal-prizes .modal__preloader').classList.remove('d-none')
		http.fxGet(endpoint, callback)
	},

	fxCreateCookie(name, value, days) {
		let expires

		if (days) {
			const date = new Date()
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))
			expires = `expires=${date.toUTCString()}`
		}
		document.cookie = `${name}=${value || ''}; ${expires}; path=/`
	},

	fxReadCookie(name) {
		let cookie = {}
		document.cookie.split(';').forEach(el => {
			let [key, value] = el.split('=')
			cookie[key.trim()] = value
		})
		return cookie[name]
	},

	fxShowFlyer(element) {
		const flyerDownloadedId = `flyer-downloaded-${element.dataset.flyerId}`
		this.el.modalFlyerCourse.textContent = element.dataset.flyerText
		this.el.modalFlyerImage.src = element.dataset.flyerImage

		if (this.fxReadCookie(flyerDownloadedId)) {
			this.el.modalFlyerInfo.classList.add('d-none')
			document.querySelector('.form-cookieless') && document.querySelector('.form-cookieless').classList.add('d-none')
			document.querySelector('.js-button-download') && document.querySelector('.js-button-download').classList.remove('d-none')
		}
	},

	events() {
		if (!this.el.modalOpen) return

		this.el.modalOpen.forEach(el => el.addEventListener('click', e => {

			this.el.body.classList.add('no-scroll-hidden')
			if (this.el.header.classList.contains('header--fixed')) {
				this.el.header.classList.add('header--modal')
				this.el.header.classList.remove('header--fixed')
			}
			this.el.modalContent.classList.remove('d-none')

			switch (true) {
				case el.hasAttribute('data-table-id'):
					e.currentTarget.hasAttribute('data-table-id') && document.querySelector('.modal-studyplans').classList.add('is-modal-open')
					this.fxGetTableStudies(el)
					break

				case el.hasAttribute('data-prize-id'):
					e.currentTarget.hasAttribute('data-prize-id') && document.querySelector('.modal-prizes').classList.add('is-modal-open')
					this.fxGetTablePrizes(el)
					break

				case el.hasAttribute('data-flyer-id'):
					e.currentTarget.hasAttribute('data-flyer-id') && document.querySelector('.modal-flyer').classList.add('is-modal-open')
					this.fxShowFlyer(el)
					break

				case el.hasAttribute('data-contacts-id'):
					e.currentTarget.hasAttribute('data-contacts-id') && document.querySelector('.modal-contacts').classList.add('is-modal-open')
					break

				case el.classList.contains('filter-search__button'):
					e.currentTarget.classList.contains('filter-search__button') && document.querySelector('.modal-filter').classList.add('is-modal-open')
					break

				case el.classList.contains('content__info-button'):
					e.currentTarget.classList.contains('content__info-button') && document.querySelector('.modal-event').classList.add('is-modal-open')
					break
			}
		}))

		if (!this.el.modalClose) return

		this.el.modalClose.forEach(el => el.addEventListener('click', () => {
			this.el.modals.forEach(el => el.classList.remove('is-modal-open'))
			this.el.body.classList.remove('no-scroll-hidden')
			if (this.el.header.classList.contains('header--modal')) {
				this.el.header.classList.remove('header--modal')
				this.el.header.classList.add('header--fixed')
			}
			this.el.modalContent.classList.add('d-none')

			this.el.modalList ? this.el.modalList.innerHTML = '' : ''
			this.el.modalTitle ? this.el.modalTitle.innerHTML = '' : ''
			this.el.modalPrizesContent ? this.el.modalPrizesContent.innerHTML = '' : ''
			if (this.el.modalCards) {
				this.el.modalCards.querySelector('.modal__item-heading').innerHTML = ''
				this.el.modalCards.querySelector('.card-avatar').innerHTML = ''
			}
		}))
	},

	init() {
		this.events()
	}
}

modal.init()